import { createContext } from 'react';
import { AuthState } from 'services/auth';

export type SessionContextValue = AuthState;

export const SessionContext = createContext<SessionContextValue | undefined>(undefined);
